import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { CompaniesItems, DefaultApi } from "@vviinn/user-managment-client-ts";

import { serializeModel } from "../../../api";
import { Status, FetchableState } from "../types";

export const fetchCompanies = createAsyncThunk(
  "companies/fetch",
  async (api: DefaultApi) => {
    const response = await api.getCompanies();
    const data = response.value;
    return data.map(serializeModel);
  },
);

type CompaniesState = FetchableState & {
  companies: CompaniesItems[];
  status: Status;
};

const initialState: CompaniesState = {
  companies: [],
  loading: false,
  error: false,
  status: "idle",
};

const companiesSlice = createSlice({
  name: "companies",
  initialState,
  reducers: {
    replaceCompany(_state, { payload }: PayloadAction<any>) {
      console.warn("REPLACE ME!!!", payload);
    },
    addCompanyToState(state, action) {
      state.companies.push(action.payload);
    },
    removeCompanyFromState(state, action) {
      const { id } = action.payload;
      state.companies = state.companies.filter((company) => company.id !== id);
    },
    changeCompaniesStatus(state, { payload }) {
      state.status = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCompanies.pending, (state) => {
      state.error = false;
      state.loading = true;
      state.status = "loading";
    });

    builder.addCase(fetchCompanies.rejected, (state) => {
      state.error = true;
      state.loading = false;
      state.status = "error";
      state.companies = [];
    });

    builder.addCase(fetchCompanies.fulfilled, (state, { payload }) => {
      state.error = false;
      state.loading = false;
      state.companies = payload;
      state.status = "fulfilled";
    });
  },
});

export default companiesSlice.reducer;
export const {
  replaceCompany,
  addCompanyToState,
  removeCompanyFromState,
  changeCompaniesStatus,
} = companiesSlice.actions;
